import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import { bindActionCreators } from "redux";
import { FormattedMessage, FormattedDate } from "react-intl";

import { EditButton } from "../../../../../common";
import { DataTable } from "../../../../../common/DataTable";
import { BlocClientsFields } from "./";

import clientStatusTypes from "../../../../clients/enums/clientStatusTypes";
import insuranceStatuses from "../../../../clients/enums/insuranceStatuses";
import billingPeriodTypes from "../../../../clients/enums/billingPeriodTypes";
import {
  CLIENTS,
  BLOCS,
  BLOC_CLIENTS,
} from "../../../../../../utils/data/models";
import * as dataActions from "../../../../../../utils/data/dataActions";
import { toLocaleDate } from "../../../../../common/dateHelper";

class BlocClientsDataTable extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.getData = this.getData.bind(this);
    this.updateBloc = this.updateBloc.bind(this);
  }

  componentWillMount() {
    this.reset();
  }

  componentWillUnmount() {
    this.reset();
  }

  getCols() {
    return [
      {
        name: <FormattedMessage id="clients.datatable.columns.client" />,
        key: "name",
        display: (client) => (
          <Link
            onlyActiveOnIndex={false}
            to={`dashboard/clients/${client.clientId}`}
            title={client.name}
          >
            {client.name}
          </Link>
        ),
        widthPct: 30,
      },
      {
        name: <FormattedMessage id="clients.datatable.columns.type" />,
        key: "clientInsuranceStatusType",
        display: (client) => (
          <FormattedMessage
            id={
              insuranceStatuses.find(
                (status) => status.value === client.clientInsuranceStatusType
              ).key
            }
          />
        ),
        widthPct: 15,
      },
      {
        name: (
          <FormattedMessage id="clients.datatable.columns.billingPeriods" />
        ),
        key: "clientBillingPeriodType",
        display: (client) => (
          <FormattedMessage
            id={
              billingPeriodTypes.find(
                (type) => type.value === client.clientBillingPeriodType
              ).key
            }
          />
        ),
        widthPct: 25,
      },
      {
        name: <FormattedMessage id="clients.datatable.columns.creationDate" />,
        key: "createdAt",
        display: (client) => (
          <FormattedDate
            value={toLocaleDate(client.createdAt)}
            year="numeric"
            month="long"
            day="2-digit"
          />
          ),
        widthPct: 20,
      },
      {
        name: <FormattedMessage id="clients.datatable.columns.status" />,
        key: "clientStatusType",
        display: (client) => (
          <div
            className={`status-indicator status-${client.clientStatusType
              .toLowerCase()
              .replace(/_/g, "-")}`}
          >
            <FormattedMessage
              id={
                clientStatusTypes.find(
                  (status) => status.value === client.clientStatusType
                ).key
              }
            />
          </div>
        ),
        widthPct: 10,
      },
    ];
  }

  generateAddButton() {
    const {
      bloc: { name },
      blocId,
      assignedClients,
      unassignedClients,
    } = this.props;
    const data = {
      name,
      assignedClients,
      unassignedClients,
      splits: [...assignedClients, ...unassignedClients],
    };

    return (
      <div>
        <EditButton
          modalClassName="extra-large-modal"
          title={
            <FormattedMessage id="admin.blocs.bloc.clients.datatable.actions.editTitle" />
          }
          label={
            <FormattedMessage id="admin.blocs.bloc.clients.datatable.actions.editButton" />
          }
          add={true}
          form={BlocClientsFields}
          data={data}
          props={{ blocId }}
          editFunction={this.updateBloc}
        />
      </div>
    );
  }

  getData(offset, limit, q, sortBy, filters) {
    const { dataActions } = this.props;

    const unassignedFields = "clientId,blocId,name";
    const unassignedSort = ["name:asc"];
    const unassignedFilter = ["clients.blocId==null", CLIENTS.archiveFilter];

    const assignedFields =
      "clientId,blocId,name,clientInsuranceStatusType,clientBillingPeriodType,createdAt,clientStatusType,isArchived";

    return Promise.all([
      dataActions.getDataList(
        CLIENTS,
        0,
        0,
        "",
        unassignedSort,
        unassignedFilter,
        {},
        {},
        unassignedFields
      ),
      dataActions.getDataList(
        BLOC_CLIENTS,
        offset,
        limit,
        q,
        sortBy,
        filters,
        {},
        {},
        assignedFields
      ),
    ]);
  }

  updateBloc(values) {
    const { dataActions, blocId } = this.props;
    const { name } = values;
    const clients = values.assignedClients.map((c) => c.clientId);

    return dataActions
      .updateDataItem(BLOCS, { blocId, clients, name })
      .then(() => {
        this.props.dataActions.getDataItem(BLOCS, blocId, {
          fields: "*,acombaInsurers(*),acombaTaxes(*)",
        });
        return this.getData(
          this.props.offset,
          this.props.limit,
          this.props.q,
          this.props.sortBy,
          this.props.filters
        );
      });
  }

  reset() {
    this.props.dataActions.clearDataList(CLIENTS);
    this.props.dataActions.clearDataList(BLOC_CLIENTS);
  }

  render() {
    const {
      assignedClients,
      filters,
      limit,
      offset,
      q,
      sortBy,
      total,
    } = this.props;
    const dataFilter = (data) => data.filter((d) => !d.isArchived);

    return (
      <DataTable
        ref="dataTable"
        getData={this.getData}
        cols={this.getCols()}
        q={q}
        filters={filters}
        offset={offset}
        data={assignedClients}
        dataFilter={dataFilter}
        rowsPerPage={limit}
        totalRows={total}
        sortBy={sortBy}
        addButton={this.generateAddButton()}
      />
    );
  }
}

BlocClientsDataTable.propTypes = {
  assignedClients: PropTypes.array,
  dataActions: PropTypes.object,
  blocId: PropTypes.string,
  filters: PropTypes.array,
  bloc: PropTypes.object,
  limit: PropTypes.number,
  offset: PropTypes.number,
  q: PropTypes.string,
  sortBy: PropTypes.array,
  total: PropTypes.number,
  unassignedClients: PropTypes.array,
};

function mapStateToProps(state, ownProps) {
  const data = state.data.blocClients || {};
  const blocs = state.data.blocs || {};
  const bloc = blocs.active || {};
  const pagination = data.pagination || {};
  const unassignedClients = state.data.clients || {};

  return {
    filters: data.filters || [`clients.blocId==${ownProps.blocId}`],
    bloc,
    limit: pagination.limit || 100,
    q: data.q,
    offset: pagination.offset || 0,
    sortBy: data.sortBy || ["name:asc"],
    total: pagination.totalCount || 0,
    assignedClients: data.items || [],
    unassignedClients: unassignedClients.items || [],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BlocClientsDataTable);



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/blocs/bloc/clients/BlocClientsDataTable.js